import React from "react";

export type JoyrideTooltipProps = {
  index: number;
  size: number;
  step?: { content?: React.ReactNode };
  backProps: Record<string, unknown>;
  closeProps: Record<string, unknown>;
  primaryProps: Record<string, unknown>;
  skipProps: Record<string, unknown>;
  tooltipProps: Record<string, unknown>;
  continuous: boolean;
  // Tour state needed for progress + hide logic
  runTour: boolean;
  stepIndex: number;
  runBookingTour: boolean;
  bookingStepIndex: number;
  canSkipTour: boolean;
};

export const CalendarJoyrideTooltip = ({
  index,
  step,
  backProps,
  primaryProps,
  skipProps,
  tooltipProps,
  runTour,
  stepIndex,
  runBookingTour,
  bookingStepIndex,
  canSkipTour,
}: JoyrideTooltipProps) => {
  const isMobile = window.innerWidth < 1024;
  const total = 15; // 9 config steps + 6 booking steps
  const current = runTour
    ? stepIndex + 1
    : runBookingTour
      ? 9 + bookingStepIndex + 1
      : Number(index) + 1;
  const isLast = current >= total && total > 0;
  const nextLabel = isLast ? "Entendido" : `Continuar (${current} paso de ${total})`;
  const hidePrimary =
    (runTour && stepIndex === 8) ||
    (runBookingTour && bookingStepIndex >= 2 && bookingStepIndex <= 4);

  return (
    <div
      {...tooltipProps}
      style={{
        // react-joyride/react-floater calcula acá la posición (top/left/transform) y el
        // z-index respecto del overlay oscuro; si no se preserva, el tooltip cae en
        // position:static/z-index:auto y queda tapado por el overlay en varios steps.
        ...(tooltipProps.style as React.CSSProperties | undefined),
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
        width: isMobile ? "calc(100vw - 2rem)" : undefined,
        maxWidth: isMobile ? "none" : 420,
        padding: isMobile ? "1.25rem 1.25rem 1rem 1.25rem" : "1rem 1rem 0.75rem 1rem",
        color: "#111827",
      }}
    >
      <div style={{ marginBottom: "0.75rem", fontSize: isMobile ? "1rem" : undefined }}>{step?.content}</div>
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.5rem",
          paddingTop: "0.25rem",
        }}
      >
        {!hidePrimary && (
          <button
            {...primaryProps}
            className="btn-primary"
            style={{
              height: isMobile ? 44 : 32,
              fontSize: isMobile ? "1rem" : "0.875rem",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: isMobile ? "0 20px" : "0 14px",
              whiteSpace: "nowrap",
              lineHeight: isMobile ? "44px" : "32px",
              width: isMobile ? "100%" : undefined,
              borderRadius: isMobile ? 10 : undefined,
            }}
          >
            {nextLabel}
          </button>
        )}
        {index > 0 && (
          <button {...backProps} className="btn-outline" style={{ height: isMobile ? 36 : 32, width: isMobile ? "100%" : undefined, borderRadius: isMobile ? 10 : undefined }}>
            Atrás
          </button>
        )}
      </div>
      {canSkipTour && (
        <div style={{ display: "flex", justifyContent: "center", paddingTop: "0.5rem" }}>
          <button
            {...skipProps}
            style={{
              background: "none",
              border: "none",
              color: "#9ca3af",
              cursor: "pointer",
              fontSize: isMobile ? "1rem" : "0.9rem",
              fontFamily: "inherit",
              fontWeight: 700,
            }}
          >
            Saltar
          </button>
        </div>
      )}
    </div>
  );
};
